{
  "Login": {
    "Title": "Masuk untuk menyimpan tanda terima Anda",
    "GoogleButton": "Lanjutkan dengan Google",
    "FacebookButton": "Lanjutkan dengan Facebook",
    "KakaoButton": "Masuk dengan Kakao",
    "NaverButton": "Masuk dengan Naver",
    "LineButton": "Masuk dengan LINE",
    "OR": "ATAU",
    "MobileNumber": "Nomor HP",
    "Continue": "Daftar dengan nomor HP",
    "EndUserLicenseAgreement": "Syarat dan Ketentuan",
    "PrivacyPolicy": "Kebijakan Privasi.",
    "EulaAndPrivacyPolicyTerm": "Dengan mendaftar, saya menyetujui \n{eula} serta {privacyPolicy}",
    "OtherLoginMethods": "Metode Login Lainnya",
    "SelectCountry": "Silakan pilih negara atau lokasi Anda",
    "EncourageSocialLogin": "Untuk pengalaman yang lebih cepat dan aman, \n{signInText}",
    "EncourageSocialLogin2": "masuk via Social Login"
  },
  "BottomNavbar": {
    "Receipts": "Tanda terima",
    "Account": "Akun"
  },
  "PhoneVerification": {
    "Title": "Verifikasi Nomor HP",
    "EnterCode": "Masukan Kode",
    "SMSDiscription": "Kode Verifikasi telah dikirim melalui SMS ke Nomor",
    "InvalidOtp": "Kode tidak valid",
    "TryAgainInfo": "Mohon mencoba kembali.",
    "OTPExpireTime": "Kode OTP akan kedaluwarsa dalam ",
    "OTPNotArrive": "Belum menerima kode?",
    "Resend": "Kirim ulang OTP",
    "ChangePhone": "Ganti Nomor HP",
    "ResendToast": "Kami telah mengirim kode OTP baru ke ponsel Anda."
  },
  "ReceiptLoader": {
    "PleaseWait": "Harap menunggu...",
    "TakingLongerText": "Tanda terima anda sedang diproses sedikit lebih lama dari biasanya...",
    "NotifyText2": "Akan kami notifikasi anda jika tanda terima sudah tersedia",
    "OKButton": "OK",
    "LoginButton": "LOGIN",
    "NotifyMeButton": "Notifikasi saya",
    "ReceiptWait": "Tanda terima anda akan segera tampil disini",
    "VoidReceiptTitle": "Tanda terima ini tidak valid",
    "VoidReceiptSubtitle": "Silakan hubungi merchant untuk informasi lebih lanjut.",
    "SharedReceiptText": "Silahkan Login untuk melihat tanda terima yang dikirimkan kepada anda.",
    "InvalidHashText": "Tidak dapat memuat tanda terima sekarang. URL tanda terima salah."
  },
  "SaveReceipt": {
    "Description": "Tanda terima Anda belum tersimpan!\nTekan tombol untuk menyimpannya.",
    "SaveReceipt": "Menyimpan tanda terima",
    "SaveInfo": "Tanda terima telah tersimpan di Piperks.",
    "UpdatedGoogleWallet": "Tersimpan di Google Wallet",
    "UpdatedSamsungWallet": "Receipt added to Samsung Wallet"
  },
  "PushNotification": {
    "NewReceipt": "Akses tanda terima baru\ndengan push notifikasi.",
    "Notification": "Notifikasi",
    "AllowNotification": "Ijinkan notifikasi dari Piperks?",
    "Deny": "Tidak",
    "Allow": "Setuju",
    "NotificationInfo": "Akan kami kabari ketika tanda terima sudah tiba"
  },
  "WhatsAppPrompt": {
    "Title": "Kami di sini untuk membantu",
    "SubTitle": "Pilih yang mau anda sampaikan:",
    "IssueWithPurchase": "Masalah dalam transaksi",
    "Feedback": "Kritik dan Saran",
    "ReceiptError": "Masalah pada tanda terima",
    "AccountIssue": "Masalah Akun",
    "ReceiptNumber": "Nomor tanda terima saya adalah {receiptNo}",
    "IssuePurchaseText": "Saya memiliki masalah dengan transaksi saya. ",
    "FeedbackText": "Saya memiliki kritik dan saran kepada anda. ",
    "ReceiptErrorText": "Saya memiliki masalah dengan tanda terima saya. ",
    "AccountIssueText": "Saya memiliki masalah pada akun saya. "
  },
  "PWAPrompt": {
    "Description": "Akses penerimaan secara offline dengan\nsatu ketukan install.",
    "Install": "INSTALL"
  },
  "AppUpdatePrompt": {
    "Description": "A newer version of Piperks is available. Please refresh the page or press the button to update it to the newest version.",
    "Title": "Update Available",
    "Button": "UPDATE"
  },
  "MyReceipts": {
    "Title": "Tanda Terima Anda",
    "ReceiptLoadingText": "Loading...",
    "EmptyInfo": "Akan lebih ramai ketika tanda terima Anda\nmulai tersimpan di sini!",
    "EmptyFilter": "Ubah pengaturan filter untuk menampilkan lebih banyak tanda terima",
    "EndOfReceipts": "Semua tanda terima telah ditampilkan"
  },
  "SalesReceipt": {
    "HelpText": "Perlu Bantuan?",
    "WhatsAppButton": "Kirim pesan melalui WhatsApp",
    "FollowUs": "Follow Us On:"
  },
  "ReceiptExport": {
    "ExportingReceiptText": "Tanda terima sedang diunduh.",
    "ReceiptExportSuccessText": "Tanda terima telah diunduh."
  },
  "Settings": {
    "ProfileCompleteText": "Lengkapi Profil Anda",
    "AccountInformation": "Informasi Akun",
    "EnterDetailsText": "Silahkan melengkapi detail Anda untuk pemulihan akun",
    "Name": "Nama",
    "Edit": "Edit",
    "Male": "Pria",
    "Phone": "Nomor Handphone",
    "Gender": "Jenis Kelamin",
    "Dob": "Tanggal Lahir",
    "Email": "Email",
    "Female": "Wanita",
    "Other": "Lainnya",
    "Indonesia": "Indonesia",
    "Malaysia": "Malaysia",
    "Singapore": "Singapura",
    "SouthKorea": "Korea Selatan",
    "Japan": "Jepang",
    "SetNow": "Atur Sekarang",
    "HomeAddress": "Alamat",
    "LocationAndLanguage": "Lokasi & Bahasa",
    "DisplayLanguage": "Silahkan pilih Bahasa yang Anda inginkan",
    "Country": "Negara",
    "Language": "Bahasa",
    "LocationAccessTitle": "Akses Lokasi",
    "LocationAccessDescription": "Mengizinkan untuk mengatur Bahasa secara otomatis.",
    "Notification": "Pemberitahuan",
    "PushNotification": "Push Notification",
    "GetUpdates": "Dapatkan update penting untuk Anda",
    "ReceiptAlerts": "Notifikasi Untuk Tanda Terima",
    "NotifiedLatestReceiptsAndUpdates": "Terima pemberitahuan untuk tanda terima terbaru dan update.",
    "LinkedAccounts": "Link Akun",
    "EnableLogins": "Aktifkan untuk login lebih cepat",
    "PwaInstallButton": "Install Piperks App",
    "ContactSupportButton": "Hubungi Bantuan",
    "LogoutButton": "Logout",
    "Version": "Versi",
    "SupportViaWhatsApp": "Bantuan melalui WhatsApp",
    "SupportViaEmail": "Bantuan melalui Email"
  },
  "Modal": {
    "PushNotif": {
      "Title": "Push notification terblokir ?",
      "Message1": "Silahkan ikuti langkah dibawah untuk mengijinkan Push Notification secara manual.",
      "Message2": "1. Klik pada ikon informasi yang berada di sebelah kiri dari URL tab.",
      "Message3": "2. Pada bagian “Notifikasi”, pilih antara “Tanya” atau “Ijinkan”. ",
      "Message4": "3. Muat ulang halaman untuk menjalankan pengaturan yang diperbaharui."
    },
    "BaseCountry": {
      "Title": "Negara",
      "Message1": "Negara yang tertera pada halaman akun anda adalah dimana data anda disimpan.",
      "Message2": "Saat ini data anda disimpan di '{0}'",
      "Message3": "Jika anda ingin mengubah lokasi dimana data anda disimpan, ",
      "Action1": "klik disini"
    }
  },
  "Message": {
    "Subject": "Dibutuhkan bantuan untuk Piperks App",
    "TypeMessage": "Silahkan ketik pesan anda disini:",
    "HelpTroubleshoot": "[JANGAN HAPUS BAGIAN INI UNTUK MEMBANTU PEMECAHAN MASALAH]",
    "PhoneModel": "Model Handphone: ",
    "PhoneOS": "Versi OS Handphone: ",
    "BrowserVersion": "Versi Browser: ",
    "RegisteredID": "ID Registrasi: ",
    "LatestReceipt": "Tanda Terima Terakhir: "
  },
  "ReceiptDetail": {
    "Store": "Toko: ",
    "POS": "POS: ",
    "Cashier": "Kasir: ",
    "TotalSpend": "TOTAL PEMBELANJAAN",
    "PreSettlementTotalSpend": "PROCESSING PAYMENT",
    "YouSave": "ANDA MENGHEMAT",
    "TotalPaid": "TOTAL PEMBAYARAN",
    "Change": "KEMBALIAN",
    "Tax": "PAJAK: ",
    "Items": "BARANG",
    "ItemReturned": "# BARANG KEMBALI ",
    "ItemSold": "# BARANG TERJUAL",
    "WifiPassword": "Salin Password Wifi",
    "FreeWifi": "WIFI GRATIS",
    "PreSettlementTotal": "INI BUKAN TANDA TERIMA FINAL ANDA.\n\nTANDA TERIMA FINAL AKAN MUNCUL SETELAH\nPEMBAYARAN BERHASIL\n"
  },
  "Receipt": {
    "Today": "Hari Ini",
    "Yesterday": "Kemarin",
    "VoidReceiptOverlay": "VOID RECEIPT"
  },
  "DataPrompt": {
    "Title": "Verifikasi Akun",
    "Body": "Amankan tanda terima anda dengan memverifikasi informasi anda untuk validasi akun atau pemulihan data di masa mendatang",
    "Gender": "Jenis Kelamin",
    "YOB": "Tahun Kelahiran",
    "Submit": "Simpan",
    "Later": "Nanti",
    "Select": "Pilih",
    "DrawerTitle": "Amankan tanda terima anda dengan memverifikasi detail akun anda",
    "DrawerBody": "Verifikasi Akun"
  },
  "Eula": {
    "Title": "Perjanjian Pengguna"
  },
  "SortFilter": {
    "Title": "Sortir dan Filter",
    "SortBy": "Urutkan berdasarkan",
    "DateAsc": "Tanggal (Lama - Baru)",
    "DateDesc": "Tanggal (Baru - Lama)",
    "TransactionAsc": "Harga (Rendah - Tinggi)",
    "TransactionDesc": "Harga (Tinggi - Rendah)",
    "DateRange": "Rentang Waktu",
    "Store": "Toko",
    "SeeMore": "Lihat Lainnya",
    "ShowLess": "Sembunyikan",
    "Apply": "Pakai",
    "Reset": "Reset",
    "LastWeek": "Seminggu Lalu",
    "LastMonth": "Sebulan Lalu"
  },
  "KoreanExplicit": {
    "Title": "Please agree to use Piperks service",
    "AcceptAll": "Accept All",
    "Required": "Required",
    "TermOfUse": "Terms of Use ",
    "PrivacyPolicy": "Privacy Policy",
    "AgeConsent": "I am 14 years old or older",
    "Continue": "Continue",
    "ViewMore": "view more"
  },
  "ReceiptSharing": {
    "Title": "Bagikan Tanda Terima",
    "SubTitle": "Bagikan Tautan ke Siapa Saja",
    "Body": "Fitur berbagi memungkinkan Anda untuk berbagi tanda terima dengan orang lain dengan membuatnya tersedia secara publik. Ketika diaktifkan, fitur ini menghasilkan tautan berbagi yang unik. Siapa pun yang menerima tautan ini dapat menggunakannya untuk melihat tanda terima yang dibagikan. Ini adalah cara yang nyaman untuk berbagi detail pembelian atau pengeluaran Anda dengan teman, keluarga, atau rekan kerja.",
    "Irreversible": "tidak dapat dibatalkan",
    "Invalid": "tidak valid",
    "ShareLinkExpiry": "Waktu Kedaluwarsa Tautan",
    "Generate": "Buat Tautan Baru",
    "GenerateShare": "Buat Tautan Berbagi Baru",
    "GenerateBody": "Catatan: Tindakan ini {0}; tautan sebelumnya akan menjadi {1}.",
    "GeneratePrompt": "Klik di bawah untuk menghasilkan tautan berbagi baru.",
    "ShareLink": "Bagikan Tautan"
  },
  "EWallet": {
    "PaymentTo": "Pembayaran ke",
    "MakePayment": "Lakukan Pembayaran",
    "PaymentProgress": "Pembayaran Sedang Diproses",
    "WaitingPayment": "Silakan tunggu beberapa detik untuk memproses pembayaran Anda ...",
    "PaymentCompleted": "Pembayaran Selesai!",
    "To": "Ke"
  },
  "Error": {
    "UnexpectedError": {
      "Title": "Kesalahan tak terduga",
      "Body": "Maaf, terjadi kesalahan. Klik tombol di bawah untuk mencoba lagi."
    },
    "TryAgain": "Harap mencoba sebentar lagi",
    "BtnTextOK": "OK",
    "BtnTextRetry": "Coba lagi",
    "OtpSendingFailed": {
      "Title": "Gagal mengirim OTP.",
      "Body": "Silakan coba lagi setelah beberapa menit."
    },
    "InvalidPhoneNumber": {
      "Title": "Gagal mengirim OTP.",
      "Body": "Nomor telepon yang Anda berikan tidak dalam format yang benar. Silakan masukkan nomor telepon Anda tanpa kode negara."
    },
    "IncorrectOtp": {
      "Title": "OTP tidak benar",
      "Body": "Silakan verifikasi OTP yang dikirim ke nomor ponsel terdaftar Anda"
    },
    "SocialLoginFailed": {
      "Title": "{ provider } Login Gagal",
      "Body": "Silakan tunggu beberapa menit sebelum mencoba lagi"
    },
    "LoginUnsuccessful": {
      "Title": "Login tidak berhasil",
      "Body": "Maaf, terjadi kesalahan saat login. Silakan coba lagi nanti"
    },
    "UserReceiptsQueryFails": {
      "Title": "Kesalahan memuat tanda terima",
      "Body": "Maaf, terjadi masalah saat memuat tanda terima Anda. Silakan coba lagi nanti"
    },
    "GetReceiptError": {
      "Title": "Kesalahan Pengambilan Tanda Terima",
      "Body": "Maaf, terjadi kesalahan tak terduga saat mengambil tanda terima Anda. Silakan coba lagi nanti."
    },
    "GetReceiptTemplateError": {
      "Title": "Pengambilan Template Gagal",
      "Body": "Maaf, terjadi kesalahan saat mengambil template tanda terima. Silakan coba lagi nanti."
    },

    "LinkedToAnotherAccountError": {
      "Title": "Tanda terima Sudah Terhubung",
      "Body": "Tanda terima ini sudah terhubung ke akun lain. Hubungi kasir untuk informasi lebih lanjut"
    },
    "LinkReceiptError": {
      "Title": "Kesalahan Penghubungan Tanda Terima",
      "Body": "Maaf, kami tidak dapat menghubungkan tanda terima ke akun Anda. Silakan coba lagi segera"
    },
    "ReceiptSubscriptionError": {
      "Title": "Gagal mengambil tanda terima secara real-time"
    },
    "AccountUpdateFailed": {
      "Title": "Pembaruan Akun Gagal",
      "Body": "Maaf, terjadi kesalahan saat memperbarui akun Anda. Silakan coba lagi nanti"
    },
    "AccountRetrievalFailed": {
      "Title": "Pengambilan Akun Gagal",
      "Body": "Maaf, terjadi kesalahan saat mengambil data akun Anda"
    },
    "ServerUnavailable": {
      "Title": "Server Tidak Tersedia",
      "Body": "Kami sedang memperbaiki masalah ini. Silakan coba lagi dalam beberapa menit"
    },
    "MissingQueryParam": {
      "Title": "Tanda Terima Tidak Ditemukan",
      "Body": "Sepertinya ada yang hilang pada tautan tanda terima Anda. Silakan periksa kembali dan coba lagi"
    },
    "InvalidReceiptToken": {
      "Title": "Link Tanda Terima Tidak Ditemukan",
      "Body": "Kami tidak dapat menemukan link tanda terima di sistem kami. Hubungi kasir untuk informasi lebih lanjut."
    },
    "ExpiredReceiptLink": {
      "Title": "Tanda Terima Kedaluwarsa",
      "Body": "Sepertinya link tanda terima telah kedaluwarsa. Hubungi kasir untuk mendapatkan tautan tanda terima baru."
    },
    "ExpiredShareReceipt": {
      "Title": "Tautan Berbagi Telah Kedaluwarsa",
      "Body": "Tautan yang dibagikan telah kedaluwarsa. Silakan minta pengirim untuk tautan baru atau periksa tautan yang dibagikan."
    },
    "InvalidShareReceipt": {
      "Title": "Tautan Berbagi Tidak Tersedia",
      "Body": "Tautan yang dibagikan tidak tersedia. Silakan minta pengirim untuk tautan baru atau periksa tautan yang dibagikan."
    }
  },
  "OfflineRenderer": {
    "Title": "Receipt",
    "Text": "No Network, Offline Receipt Displayed",
    "Subtext": "Full receipt details will appear when online",
    "StoreNo": "Store No:",
    "ReceiptNo": "Receipt No:",
    "TotalAmount": "Total Amount",
    "PaymentMethod": "Payment Method"
  }
}
